import React from "react";
import { ISurveyQuestion } from "../../../models/survey/survey-question.model";
import waistSvg from "../../../assets/images/survey-custom/waist.svg";
import SurveyAnswerCustomMap, { IMapConfig } from "./survey-answer-custom-map";

export interface ISurveyAnswerWaistPartsProps {
    question: ISurveyQuestion;
    value: string | number | Array<string | number> | null;
    onChange: (value: string | number | Array<string | number>) => void;
    onSave?: (value: string | number | Array<string | number>, shouldClose?: boolean) => void;
}

const WAIST_PARTS = [
    { key: "LOW WAIST", id: "low" },
    { key: "MID WAIST", id: "mid" },
    { key: "HIGH WAIST", id: "high" },
];

const mapConfig: IMapConfig = {
    type: "id",
    regions: WAIST_PARTS,
    svgStyle: {
        fill: "#ffffff",
        stroke: "rgba(42, 30, 47, 0.42)",
        strokeWidth: 2,
    },
};

const SurveyAnswerWaistParts: React.FC<ISurveyAnswerWaistPartsProps> = ({
    question,
    value,
    onChange,
    onSave,
}) => {
    return (
        <SurveyAnswerCustomMap
            question={question}
            value={value}
            onChange={onChange}
            onSave={onSave}
            svgPath={waistSvg}
            mapConfig={mapConfig}
            ariaLabel="Mapa stanu spodni"
        />
    );
};

export default SurveyAnswerWaistParts;
